import { AwardingClient } from "@/utils/EvoClient";
import { CreateAwardUnitDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/create-award-unit";

export default async function createAwardUnit(
  dto: CreateAwardUnitDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
